class MessageDto {

    message = '';
    type = '';

    constructor(message, type) {
        this.message = message;
        this.type = type;
    }
}

MessageDto.SUCCESS_TYPE = 'success';
MessageDto.WARNING_TYPE = 'warning';
MessageDto.INFO_TYPE = 'info';
MessageDto.ERROR_TYPE = 'danger';

export default MessageDto;